module.exports = __webpack_public_path__ + "static/img/05019B_1_2_R_20200909_fit.8460865.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/05019B_1_2_R_20200909_fit.png
// module id = D5WV
// module chunks = 0